import { FormControl, Select, MenuItem, Grid } from "@mui/material";
import { useState, useEffect, useCallback } from "react";

const CitizenshipStatus = ({ page, setPage, formData, setFormData }) => {
    const [citizenshipError, setCitizenshipError] = useState(null);
    const [addressMonthsError, setAddressMonthsError] = useState(null);

    const onCitizenshipChange = (e) => {
        setFormData({ ...formData, canadianStatus: e.target.value });
        setCitizenshipError(null);
    }
    const onAddressMonthsChange = (e) => {
        setFormData({ ...formData, addressLengthMonths: parseInt(e.target.value, 10) });
        setAddressMonthsError(null);
    }

    const updateFormData = useCallback(() => {
        setFormData(formData);
    }, [formData, setFormData]);

    useEffect(() => {
        updateFormData();
    }, [updateFormData]);

    useEffect(() => {
        setCitizenshipError(null);
        setAddressMonthsError(null);
    }, [formData.lang]);

    const validateData = () => {
        var valid = true;

        if (formData.canadianStatus === "") {
            setCitizenshipError(formData.lang === "fr" ? "Veuillez indiquer votre statut de citoyenneté" : "Please provide your citizenship status");
            valid = false;
        } else {
            setCitizenshipError(null);
        }

        if (formData.addressLengthMonths === "") {
            setAddressMonthsError(formData.lang === "fr" ? "Ceci est nécessaire" : "This is required");
            valid = false;
        } else if (isNaN(formData.addressLengthMonths)) {
            setAddressMonthsError(formData.lang === "fr" ? "Veuillez saisir un nombre entier" : "Please enter a whole number");
            valid = false;
        } else {
            setAddressMonthsError(null);
        }

        if (valid) {
            window.dataLayer.push({'event': 'loan_step9', 'loanEvent': 'step9', 'loanEventID': 10});
            // quebec only
            // window.dataLayer.push({'event': 'loan_step9q', 'loanEvent': 'step9q', 'loanEventID': '10q'});
            setPage(page + 1);
        }
    }

    return (
        <div className="card">
            <div className="card-div">
                <div className="textfield-label">{formData.lang === "fr" ? "Quel est votre statut de citoyen?" : "What is your citizenship status?"}</div>
                <FormControl>
                    <Select
                        variant="outlined"
                        defaultValue="citizen"
                        value={formData.canadianStatus}
                        onChange={onCitizenshipChange}
                    >
                        <MenuItem value={"pr"}>{formData.lang === "fr" ? "Résident permanent" : "Permanent Resident"}</MenuItem>
                        <MenuItem value={"citizen"}>{formData.lang === "fr" ? "Citoyen" : "Citizen"}</MenuItem>
                        <MenuItem value={"work_permit"}>{formData.lang === "fr" ? "Permis de travail" : "Work Permit"}</MenuItem>
                        <MenuItem value={"student_visa"}>{formData.lang === "fr" ? "Visa d'étudiant" : "Student Visa"}</MenuItem>
                        <MenuItem value={"other"}>{formData.lang === "fr" ? "Autre" : "Other"}</MenuItem>
                    </Select>
                </FormControl>
                <div className="error-text">{citizenshipError}</div>
                <div className="textfield-label">{formData.lang === "fr" ? "Depuis combien de mois habitez-vous à votre adresse?" : "How many months have you lived at your address?"}</div>
                <FormControl>
                    <Select
                        variant="outlined"
                        value={formData.addressLengthMonths}
                        onChange={onAddressMonthsChange}
                    >
                        <MenuItem value={"6"}>{formData.lang === "fr" ? "6 mois" : "6 months"}</MenuItem>
                        <MenuItem value={"12"}>{formData.lang === "fr" ? "1 an" : "1 year"}</MenuItem>
                        <MenuItem value={"24"}>{formData.lang === "fr" ? "2 ans" : "2 years"}</MenuItem>
                        <MenuItem value={"36"}>{formData.lang === "fr" ? "Plus de 3 ans" : "3+ years"}</MenuItem>
                    </Select>
                </FormControl>
                <div className="error-text">{addressMonthsError}</div>

                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <button className="nav-button"
                            onClick={() => {
                                setPage(page - 1);
                            }}>
                            {formData.lang === "fr" ? "Précédent" : "Previous"}
                        </button>
                    </Grid>
                    <Grid item xs={6}>
                        <button className="nav-button"
                            onClick={() => {
                                validateData();
                            }}>
                            {formData.lang === "fr" ? "Suivant" : "Next"}
                        </button>
                    </Grid>
                </Grid>
            </div>
        </div>
    );
};

export default CitizenshipStatus;